import { render, staticRenderFns } from "./AddSancion.vue?vue&type=template&id=035c1799"
import script from "./AddSancion.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSancion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports